












































import Vue from 'vue';
import Component from 'vue-class-component';
import ModelAutocomplete from '@/general/component/form/autocomplete/ModelAutocomplete.vue';
import PageContainer from '@/general/component/PageContainer.vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocompleteTS.vue';
import FacilityRouter from '@/context/facility/router/FacilityRouter';
import { facilityApi } from '@/context/facility/api/FacilityApi';
import { FacilityFilter } from '@/context/facility/model/FacilityFilter';
import { Api } from '@/common/api/Api';
import CustomerAutocomplete from '@/general/component/form/autocomplete/CustomerAutocomplete.vue';
import ColoredBooleanField from "@/general/component/ColoredBooleanField.vue";

@Component({
  components: {
    ColoredBooleanField,
    CustomerAutocomplete,
    PageContainer,
    FacilityAutocomplete,
    ModelAutocomplete,
    TextInput
  }
})
export default class FacilityListContainer extends Vue {
  router: FacilityRouter = new FacilityRouter();
  filter: FacilityFilter = new FacilityFilter();
  entityHeaders: Array<Record<string, unknown>> = [
    {
      text: "Numer sklepu",
      value: "storeNumber",
      align: "left"
    },
    {
      text: "Area",
      value: "area",
      align: "left"
    },
    {
      text: "Klient",
      value: "clientName",
      align: "left"
    },
    {
      text: "Ulica",
      value: "street",
      align: "left"
    },
    {
      text: "Centrum handlowe",
      value: "mall",
      align: "left"
    },
    {
      text: "Miasto",
      value: "city",
      align: "left"
    },
    {
      text: "Kraj",
      value: "country",
      align: "left"
    },
    {
      text: "Aktywny",
      value: "active",
      align: "left"
    }
  ];
  api: Api = facilityApi;
}
